/*
 * View for the topic title.  Nothing fancy.
 */

define(["marionette", "./template/topicTitleTemplate.html"], function (
  Marionette,
  TopicTitleTemplate,
) {
  var TopicTitleView = {};

  TopicTitleView.topicTitleView = Marionette.ItemView.extend({
    template: TopicTitleTemplate,
    nameError: function (errorMessage) {
      this.$el
        .find("#topicTitleText")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: function () {
      if (this.model.allowEditTopicName) {
        return {
          "#topicTitleText": {
            enableSelector: "#topicTitle",
            modelAttribute: "intentName",
            placeholder: "topic.titlePlaceholder",
            textArea: false,
          },
        };
      }
    },
  });

  return TopicTitleView;
});
